module.exports = {
  baseUrl: 'https://stagingnew.health', //not in use
  ClinicBaseUrl: 'https://api-v4.staging.iris-health.com',
  systemName: 'System dev',
  company: 'iris',
  favicon: '../assets/iris-health-logo.jpeg',
  companyName: 'Iris Health',
  copyRight: 'Iris Health is a trademark of its respective owner.',
};
